import { toasts, dismissToast } from "../lib/toast.js";

export function Toasts() {
  const items = toasts.value;
  if (items.length === 0) return null;

  return (
    <div
      aria-live="polite"
      class="fixed bottom-4 right-4 z-50 flex flex-col gap-2"
    >
      {items.map((t) => (
        <div
          key={t.id}
          class={`rounded-lg px-4 py-3 text-sm shadow-lg ${
            t.type === "success"
              ? "bg-green-600 text-white"
              : t.type === "error"
                ? "bg-red-600 text-white"
                : "bg-blue-600 text-white"
          }`}
        >
          <div class="flex items-center justify-between gap-3">
            <span>{t.message}</span>
            <button
              onClick={() => dismissToast(t.id)}
              class="opacity-70 hover:opacity-100"
              aria-label="Dismiss"
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
